module.exports = __webpack_public_path__ + "img/img4.49b2687.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img4.png
// module id = 375
// module chunks = 0